<div class="w-full sm:flex-none sm:w-full px-2">
    <app-dialog-overlay #jobTitleDialog></app-dialog-overlay>
</div>
<div class="flex flex-wrap -mx-2" *ngIf="searchType === 'basic'">
    <div class="w-full sm:flex-none sm:w-full px-2" *ngIf="!hideTitle">
        <small class="block">
            Search by job title keywords, separated by commas.
        </small>
    </div>

    <div class="w-full sm:flex-none sm:w-full px-2">
        <mat-form-field *ngIf="!hasBooleanAttribute" appearance="outline" class="mb-2 w-full no-padding mt-1">
            <mat-label>Title Keywords</mat-label>
            <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                autocomplete="off"
                name="jobTitle"
                placeholder="Example: HRIS, benefits"
                [(ngModel)]="data.job_title"
                (ngModelChange)="isValidJobTitle('job_title')"
                [disabled]="disabled"
                >
            </textarea>
        </mat-form-field>
        <mat-form-field *ngIf="hasBooleanAttribute" appearance="outline" class="mb-2 w-full no-padding mt-1">
            <mat-label>Title Keywords</mat-label>
            <textarea
                matInput
                name="jobTitle"
                class="resize-none"
                placeholder="HRIS, benefits"
                [(ngModel)]="data.job_title"
                (ngModelChange)="isValidJobTitle('job_title')"
                (keydown)="preventDefaultBehaviour($event)"
                cdkTextareaAutosize
                rows="1"
                [textValue]="data.job_title"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                [lineHeight]="24"
                [disabled]="disabled"
            ></textarea>
        </mat-form-field>
    </div>

    <div class="w-full sm:flex-none sm:w-full px-2" *ngIf="hasBooleanAttribute && !hideAdvancedSwitch">
        <p class="text-primary text-right mt-1 cursor-pointer" (click)="toggleSearchType($event, 'advanced')">Switch to
            advanced search</p>
    </div>
</div>

<div class="flex flex-wrap -mx-2" *ngIf="hasBooleanAttribute && searchType === 'advanced'">
    <div class="w-full sm:flex-none sm:w-full p-4" *ngIf="!hideTitle">
        <small class="block">
            Search by job title keywords, separated by commas.
        </small>
    </div>

    <div class="w-full sm:flex-none sm:w-full px-2">
        <small><b>INCLUDE:</b></small>
    </div>
    <div class="w-full sm:flex-none sm:w-full px-2">
        <small>ANY of these keywords</small>
        <mat-form-field appearance="outline" class="mb-2 w-full no-padding mt-1">
            <mat-label>ANY</mat-label>
            <textarea
                matInput
                name="jobTitleAny"
                class="resize-none"
                placeholder="HRIS, benefits" [(ngModel)]="data.job_title_any"
                (ngModelChange)="isValidJobTitle('job_title_any')" (keydown)="preventDefaultBehaviour($event)"
                cdkTextareaAutosize
                rows="1"
                [textValue]="data.job_title_any"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                [lineHeight]="24"
                [disabled]="disabled"
            ></textarea>
        </mat-form-field>
    </div>
    <div class="w-full sm:flex-none sm:w-full mt-1 px-2">
        <small>ALL of these keywords</small>
        <mat-form-field appearance="outline" class="mb-2 w-full no-padding mt-1">
            <mat-label>ALL</mat-label>
            <textarea
                matInput
                name="jobTitleAll"
                class="resize-none"
                placeholder="HRIS, benefits" [(ngModel)]="data.job_title_all"
                (ngModelChange)="isValidJobTitle('job_title_all')" (keydown)="preventDefaultBehaviour($event)"
                cdkTextareaAutosize
                rows="1"
                [textValue]="data.job_title_all"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                [lineHeight]="24"
                [disabled]="disabled"
            ></textarea>
        </mat-form-field>
    </div>
    <div class="w-full sm:flex-none sm:w-full mt-1 px-2">
        <small>NONE of these keywords</small>
        <mat-form-field appearance="outline" class="mb-2 w-full no-padding mt-1">
            <mat-label>NONE</mat-label>
            <textarea
                matInput
                name="jobTitleNone"
                class="resize-none"
                placeholder="HRIS, benefits" [(ngModel)]="data.job_title_none"
                (ngModelChange)="isValidJobTitle('job_title_none')" (keydown)="preventDefaultBehaviour($event)"
                cdkTextareaAutosize
                rows="1"
                [textValue]="data.job_title_none"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                [lineHeight]="24"
                [disabled]="disabled"
            ></textarea>
        </mat-form-field>
    </div>
    <div class="w-full sm:flex-none sm:w-full px-2">
        <p class="text-primary text-right mt-1 cursor-pointer" (click)="toggleSearchType($event, 'basic')">Switch to
            basic search</p>
    </div>
</div>
